










































import { defineComponent, PropType, computed, useContext, ref } from '@nuxtjs/composition-api';
import dayjs from 'dayjs';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import AppImage from '~/components/partials/App/AppImage.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import { SMARTPHONE } from '~/constants/breakpoint';
import { THUMBNAIL_300, THUMBNAIL_400 } from '~/constants/profilesForImage';
import { url } from '~/utils';
import { EventSummaryResponseSchema } from '~/types/modules/event';
import { SeatsLeft, EventStatus, EventCategoryKeys } from '~/enums';

export default defineComponent({
  components: {
    AppIcon,
    AppImage,
    AppLink,
  },
  props: {
    event: {
      type: Object as PropType<EventSummaryResponseSchema>,
      required: true,
    },
    tags: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
  },
  setup(props) {
    const { app } = useContext();
    const isSmartPhone = ref(app.$ua.deviceType() === SMARTPHONE);

    const detailPath = computed(() => url('EVENT_DETAIL', { id: props.event.id }));

    const displayStartDate = computed(() => dayjs(props.event.startDate || null));
    const displayEndDate = computed(() => {
      const endDate = dayjs(props.event.endDate || null);
      return endDate.isSame(displayStartDate.value) ? dayjs(null) : endDate;
    });

    const categoryLabel = computed(() => {
      const { category } = props.event;
      switch (category) {
        case EventCategoryKeys.EVENT:
          return 'イベント';
        case EventCategoryKeys.TASTING:
          return 'テイスティング';
        case EventCategoryKeys.DINNER_LUNCH:
          return 'ディナー・ランチ';
        case EventCategoryKeys.SEMINAR:
          return 'セミナー';
        default:
          return 'その他';
      }
    });

    const isCanceled = computed(() => props.event.status === EventStatus.CANCELED);

    return {
      detailPath,
      displayStartDate,
      displayEndDate,
      categoryLabel,
      isCanceled,
      SeatsLeft,
      isSmartPhone,
      THUMBNAIL_300,
      THUMBNAIL_400,
    };
  },
});
